import type { SenderType } from 'bundles/ai-coach-platform/components/patterns/chat/types';
import type { CoachRecommendedActionFragment } from 'bundles/ai-coach-platform/queries/__generated__/coachRecommendedActionFragment';
import type { CoachRecommendedEditFragment } from 'bundles/ai-coach-platform/queries/__generated__/coachRecommendedEditFragment';
import type { CourseraContextFragment } from 'bundles/ai-coach-platform/queries/__generated__/courseraContextFragment';
import type { ItemNavigationButtonFragment } from 'bundles/ai-coach-platform/queries/__generated__/navigationButtonFragment';
import type { CoachActionType } from 'bundles/ai-coach-platform/types';

import { MESSAGES_TYPES, MESSAGE_SENDER, getErrorMessageText } from '../constants';
import type { Feedback, MessageTypes as MessageI, MessageTypes, StructuredResponse } from '../store/types';

export const isClientMessage = (sender: SenderType | string) => sender === MESSAGE_SENDER.CLIENT;
export const isCoachMessage = (sender: SenderType | string) => sender === MESSAGE_SENDER.RESPONSE;

export const isTextMessage = (message: MessageTypes) => message.type === 'text';
export const isErrorMessage = (message: MessageTypes) => message.text === getErrorMessageText();

export function createNewMessage({
  text,
  sender,
  id,
  userFeedback,
  timestamp,
  action,
  navigationButtons,
  structuredResponse,
  recommendedActions,
  courseraContext,
  recommendedEdits,
}: {
  text: string;
  sender: string;
  id?: string;
  userFeedback?: Feedback | null;
  timestamp?: number;
  action?: CoachActionType;
  navigationButtons?: ItemNavigationButtonFragment[] | null;
  structuredResponse?: StructuredResponse;
  recommendedActions?: CoachRecommendedActionFragment[];
  courseraContext?: CourseraContextFragment | null;
  recommendedEdits?: CoachRecommendedEditFragment[] | null;
}): MessageI {
  return {
    type: MESSAGES_TYPES.TEXT,
    text,
    sender,
    timestamp: timestamp ?? Date.now(),
    showAvatar: true,
    customId: id,
    unread: sender === MESSAGE_SENDER.RESPONSE,
    userFeedback,
    action,
    navigationButtons,
    structuredResponse,
    recommendedActions,
    courseraContext,
    recommendedEdits,
  };
}
